import { getSelectedConfiguration } from '@/model/draft/getSelectedConfiguration';
import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';
import { getErrorForConfiguration } from './getErrorForConfiguration';

export function getErrorForSelectedConfiguration(state: StoreState) {
  const selectedConfiguration = getSelectedConfiguration(getDraft(state));
  return (
    selectedConfiguration &&
    getErrorForConfiguration(state, getSelectedConfiguration(getDraft(state)))
  );
}
